<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-tabs
          slider-color="primary"
          v-model="tab"
        >
          <v-tab
            v-for="(resource, index) of resources"
            :key="`tab${index}`"
          >
            {{ resource.namePlural }}
          </v-tab>
        </v-tabs>

        <data-table :resource="Object.values(resources)[tab]" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { pickBy } from "lodash";

export default {
  data() {
    return {
      tab: 0
    };
  },

  computed: {
    resources() {
      return Object.values(
        pickBy(this.$store.state.resources, item => {
          return item.systemSetup;
        })
      ).sort((a, b) => {
        return a.name < b.name ? -1 : 1;
      });
    }
  },

  components: {
    DataTable
  }
};
</script>

<style scoped>
</style>
